import React from "react";
import bg from "../../Assets/hero-cover.png";
import { MdArrowOutward } from "react-icons/md";
import { GiPlainSquare } from "react-icons/gi";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Pagination, Autoplay } from "swiper/modules";
import home from "../../Assets/Hero.webp";
import { useNavigate } from "react-router-dom";
import CountUp from "react-countup"; // Import CountUp

const Home = () => {
const slides = [
  { 
    number: 15, 
    text: "Y e a r s  \n e x p e r i e n c e",
    description: "With 15 years of expertise, we have built a legacy of excellence in the industry. Our commitment to innovation, quality, and customer satisfaction has made us a trusted name in construction and development."
  },
  { 
    number: 125, 
    text: "P r o j e c t s \n  c o m p l e t e d",
    description: "Over 125 successful projects delivered with precision, innovation, and quality. From residential homes to large-scale commercial ventures, our portfolio showcases our ability to bring visions to reality with perfection."
  },
];
  const navigate = useNavigate();

  return (
    <>
      {/* Banner Image */}
      <div className="max-w-screen-2xl mx-auto">
        <img
          src={home}
          alt="home"
          className="w-full h-[300px] object-cover bg-top"
        />
      </div>
      {/* Main Section */}
      <div className="flex flex-col md:flex-row max-w-screen-2xl mx-auto">
        {/* Left Section */}
        <div className="relative w-full md:w-[55%] bg-white h-auto md:h-80 p-5 pl-8">
          <div className="flex justify-center md:justify-end">
            <img
              src={bg}
              alt="background"
              className="h-40 md:h-72 w-[70%] object-contain"
            />
          </div>
          <div className="absolute inset-0 md:w-[70%] p-4 md:-mt-0 -mt-4 md:p-8">
            <h1 className="text-3xl md:text-5xl poppins-semibold text-black">
              Let's Build Future <br /> Homes With Us.
            </h1>
            <p className="mt-2 text-xs md:text-sm font-normal text-gray-600 pb-2">
              Our diverse portfolio represents decades of construction
              experience backed by a passion for quality, outstanding client
              service, and the latest industry trends.
            </p>

            <button
              className="flex items-center gap-4 bg-[#068b07] text-white md:text-md font-medium px-4 py-1 mb-3 md:px-4 md:py-2 md:mt-3"
              onClick={() => navigate("/about")}
            >
              <span>Read More</span>
              <MdArrowOutward
                className="bg-[#121315] text-white p-1"
                size={32}
              />
            </button>
          </div>
        </div>

        {/* Right Section */}
        <div className="w-full md:w-[45%] bg-[#121315] p-6 md:p-8">
          <Swiper
            modules={[Pagination, Autoplay]}
            autoplay={{ delay: 3000 }}
            loop={true}
            breakpoints={{
              640: { slidesPerView: 1 },
              768: { slidesPerView: 1 },
              1024: { slidesPerView: 1 },
            }}
            className="w-full"
          >
            {slides.map((slide, index) => (
              <SwiperSlide key={index}>
                <div className="flex border-b max-w-xs">
                  <span className="text-[#184497] text-5xl md:text-7xl font-medium p-3">
                    <CountUp
                      start={0}
                      end={slide.number}
                      duration={2}
                      suffix={slide.number >= 100 ? "+" : ""}
                    />
                  </span>
                  <span className="text-white pt-4 md:pt-8 text-sm md:text-base">
                    {slide.text.split("\n").map((line, i) => (
                      <div key={i}>{line}</div>
                    ))}
                  </span>
                </div>
                <div className="max-w-xs text-white">
                  <p className="text-xs md:text-sm text-justify pt-3">
                    {slide.description}
                  </p>
                </div>
                <div className="flex gap-4 mt-5">
                  <GiPlainSquare className="text-[#068b07] p-0.5" size={12} />
                  <GiPlainSquare className="text-white p-0.5" size={12} />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </>
  );
};

export default Home;
